@if (regioverantwoordelijke$ | async; as regioverantwoordelijke) {
  <zah-upsert-regioverantwoordelijke
    [regioverantwoordelijke]="regioverantwoordelijke"
    okLabel="Bewaar"
    (cancelClicked)="onCancelClicked()"
    (okClicked)="onEditClicked($event)">
  </zah-upsert-regioverantwoordelijke>
}
